import moment from "moment";
// 常用工具库

// 只返回原始对象有值的属性
//这个方法不会影响原来的对象，而是返回一个新对象
export const filterParams = obj => {
  let _newPar = {};
  for (let key in obj) {
    //如果对象属性的值不为空，就保存该属性（这里我做了限制，如果属性的值为0，保存该属性。如果属性的值全部是空格，属于为空。）
    if (
      (obj[key] === 0 || obj[key]) &&
      obj[key].toString().replace(/(^\s*)|(\s*$)/g, "") !== ""
    ) {
      //记录属性
      _newPar[key] = obj[key];
    }
  }
  //返回对象
  return _newPar;
};

// 格式化日期字符串
export const formatDate = (dateStr, format = "YY/MM/DD") => {
  try {
    const m = moment(dateStr);
    if (m.isValid()) {
      return m.format(format);
    } else {
      return "-";
    }
  } catch (error) {
    return "-";
  }
};

export const getOldHost = () => {
  return process.env.REACT_APP_OLDER_SITE_DOMAIN;
};

// 获取地址栏参数
export const getSearchVal = (search, name: any) => {
  search = decodeURI(search);
  const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
};

// 判断对象是否包含某对象，返回对象原值或null值 propertys: string | Array
export const getPropertysValues = (current: object, propertys: any) => {
  // 返回原值或默认值
  const returnValue = property => {
    if (current.hasOwnProperty(property)) {
      return current[property];
    } else {
      return null;
    }
  };

  if (typeof propertys === "string") {
    return returnValue(propertys);
  } else if (propertys instanceof Array) {
    const value = {};
    propertys.forEach(item => (value[item] = returnValue(item)));
    return value;
  } else {
    return null;
  }
};

// 检查是否为Url
export const checkUrl = str => {
  var urlRegex =
    "^(?!mailto:)(?:(?:http|https|ftp)://)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$";
  var url = new RegExp(urlRegex, "i");
  return str.length < 2083 && url.test(str);
};

/**
 * 函数节流方法
 * @this throttle
 * @param Function fn 延时调用函数
 * @param Number delay 延迟多长时间
 * @param Number atleast 至少多长时间触发一次
 */
export function throttle(fn: any, delay: number, atleast: number = 0) {
  let timer: any = null;
  let previous: any = null;

  return function (this: any) {
    const now = +new Date();
    // todo this是否等于参数
    const context = this;
    const args = arguments;
    if (!previous) {
      previous = now;
    }
    if (atleast && now - previous > atleast) {
      fn.apply(context, args);
      // 重置上一次开始时间为本次结束时间
      previous = now;
      clearTimeout(timer);
    } else {
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(context, args);
        previous = null;
      }, delay);
    }
  };
};
